import type { PreparedExperience } from '@/shared/lib/experience/mapExperienceToCard';

// Мини-карточка в «Вы недавно смотрели» показывает сокращённый набор данных.
// Тизер, длительность, тип перемещения и счётчик отзывов нужны только
// полноразмерной карточке в ленте: `is-mini-card` их не скрывает, поэтому
// набор пропсов задаётся здесь явно, а не спредом всего маппера.
export const toMiniCardProps = (experience: PreparedExperience) => ({
  id: experience.id,
  title: experience.title,
  experienceType: experience.experienceType,
  link: experience.link,
  city: experience.city,
  cityLink: experience.cityLink,
  imageLink: experience.imageLink,
  imageAltText: experience.imageAltText,
  rating: experience.rating,
  price: experience.price,
  priceFrom: experience.priceFrom,
  currency: experience.currency,
  unit: experience.unit,
  discount: experience.discount,
  originalPrice: experience.originalPrice,
  maxPersonsRange: experience.maxPersonsRange,
  discountExpirationText: experience.discountExpirationText,
  tour: experience.tour,
  count: experience.count,
  inactive: experience.inactive,
  maxPersons: experience.maxPersons,
  favorite: experience.favorite,
  guideId: experience.guideId,
  type: experience.type,
  format: experience.format,
  instantBooking: experience.instantBooking,
  paidPromotion: experience.paidPromotion,
});
